import {logout} from 'lib/utils/loginUtils';
import { globalRouter } from './global-router';

export const callAsyncBackend = (apiCallingAsyncFunction, successResponseAsyncFunction, errorResponseAsyncFunction) => {
    return apiCallingAsyncFunction()
        .then(response => {
            if (response?.status >= 200 && response?.status < 300) {
                return successResponseAsyncFunction(response);
            } else if (response?.status === 401) {
                logout();
                return globalRouter.navigate('/login', { state: { isTokenExpired: true }});
            } else {
                if (errorResponseAsyncFunction) {
                    return errorResponseAsyncFunction(response);
                } else {
                    throw new Error(response?.statusText);
                }
            }
        });
}